var m;

m = require('mithril');

module.exports = {
  view: function(ctrl, args) {
    return m('.ViewOptions', [
      m('label', [
        'View: ', m('select', {
          value: args.view(),
          onchange: m.withAttr('value', args.onViewSelect)
        }, [
          m('option', {
            value: 'grid'
          }, 'Grid'), m('option', {
            value: 'date'
          }, 'By date')
        ])
      ])
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9WaWV3T3B0aW9ucy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy91aS9jb21wb25lbnRzL1ZpZXdPcHRpb25zLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtXQUNMLENBQUEsQ0FBRSxjQUFGLEVBQWtCO01BQ2pCLENBQUEsQ0FBRSxPQUFGLEVBQVc7UUFDVixRQURVLEVBRVYsQ0FBQSxDQUFFLFFBQUYsRUFBWTtVQUNYLEtBQUEsRUFBTyxJQUFJLENBQUMsSUFBTCxDQUFBLENBREk7VUFFWCxRQUFBLEVBQVUsQ0FBQyxDQUFDLFFBQUYsQ0FBVyxPQUFYLEVBQW9CLElBQUksQ0FBQyxZQUF6QixDQUZDO1NBQVosRUFHRztVQUNGLENBQUEsQ0FBRSxRQUFGLEVBQVk7WUFBQyxLQUFBLEVBQU8sTUFBUjtXQUFaLEVBQTZCLE1BQTdCLENBREUsRUFFRixDQUFBLENBQUUsUUFBRixFQUFZO1lBQUMsS0FBQSxFQUFPLE1BQVI7V0FBWixFQUE2QixTQUE3QixDQUZFO1NBSEgsQ0FGVTtPQUFYLENBRGlCO0tBQWxCO0VBREssQ0FEVSJ9
